export default {
	id: "imac-pro",
	title: "iMac Pro",
	company: "Apple",
	styles: [
		{
			title: "normal",
			pos: ["4.8%", "4%", "32%", "4%"],
			colors: [
				{
					title: "space-grey",
					hex: "#2E2E34",
					img: require("./original/space-grey.png")
				}
			]
		}
	]
};
